// scope ごとの ActionCable Channel 名と購読パラメータを生成するヘルパー
// identifierKey が null の scope（例: inbox）はユーザー単位の購読となるため
// チャネル識別子（targetId）を含めない。
const SCOPE_CONFIG = {
  dm: {
    channelName: 'MessageRoomChannel',
    identifierKey: 'message_group_id',
  },
  circle: {
    channelName: 'CircleMessageChannel',
    identifierKey: 'circle_id',
  },
  event: {
    channelName: 'EventMessageChannel',
    identifierKey: 'event_id',
  },
  inbox: {
    channelName: 'MessageInboxChannel',
    identifierKey: null,
  },
};

export function buildSubscriptionParams(scope, targetId) {
  const config = SCOPE_CONFIG[scope];
  if (!config) {
    throw new Error(`Unknown scope: ${scope}`);
  }
  if (config.identifierKey === null) {
    return { channel: config.channelName };
  }
  return {
    channel: config.channelName,
    [config.identifierKey]: targetId,
  };
}

export function getIdentifierKey(scope) {
  const config = SCOPE_CONFIG[scope];
  if (!config) {
    throw new Error(`Unknown scope: ${scope}`);
  }
  return config.identifierKey;
}

export default { buildSubscriptionParams, getIdentifierKey };
